import { render } from "./ConfiguracionComponent.vue?vue&type=template&id=67a9bd1f&scoped=true"
import script from "./ConfiguracionComponent.vue?vue&type=script&lang=js"
export * from "./ConfiguracionComponent.vue?vue&type=script&lang=js"

import "./ConfiguracionComponent.vue?vue&type=style&index=0&id=67a9bd1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a9bd1f"]])

export default __exports__